import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import store from './store'

const es6promise = require('es6-promise');

if(!(typeof Promise !== "undefined" && Promise.toString().indexOf("[native code]") !== -1)) {
  es6promise.polyfill();
}

// if(localStorage.jwt) {
//   setAuthorizationToken(localStorage.jwt);
//   store.dispatch(userLoggedIn(jwtdecode(localStorage.jwt)));
// }

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js